import React from "react";
import Layout from "components/Layout";
import { getCommonStaticProps } from "@/utils/method";
import ThirdPartyBuy from "@/components/Pages/Credit/ThirdPartyBuy";

export default function DebitCardPage() {
  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      <ThirdPartyBuy />
    </Layout>
  );
}

export async function getStaticProps(context) {
  return getCommonStaticProps(context, "/credit/debitCard");
}
